__turbopack_context__.v({
  "image": "styles-module__yKO0TW__image",
  "includingFeesText": "styles-module__yKO0TW__includingFeesText",
  "sizeName": "styles-module__yKO0TW__sizeName",
  "wrapper": "styles-module__yKO0TW__wrapper",
});
